export enum ONBOARDING_STATUS {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    INCOMPLETE = 'INCOMPLETE'
}